export const getAtRetirement = state => state.atRetirement;
